export default [
  {
    key: 'date',
    label: 'field.date',
    rules: 'required',
    type: 'date',
    cols: 12,
  },
]
